'use strict';

var address = require('./address'),
	ajax = require('../../ajax'),
	dialog = require('../../dialog'),
	formPrepare = require('./formPrepare'),
	shippingMethods = require('./shippingMethods'),
	giftcert = require('../../giftcert'),
	jcalendar = require('../../jcalendar'),
	util = require('../../util'),
	loqate = require('../../loqate'),
	linchpin = require('int_googletagmanager/linchpin/multiship'),
	linchpinCheckout = require('int_googletagmanager/linchpin/checkoutInfo'),
	cart = require('site/pages/cart'),
	_ = require('lodash');

/**
 * @function
 * @description Initializes tools for switching between gift messages on the shipment level and on individual items in a shipment.
 */
function initGifting() {
	var $multishipForm = $('form.checkout-multi-shipping'),
		$changegiftoptions = $multishipForm.find('button[name$="multishipping_shippingOptions_gift"]');

	$changegiftoptions.on('click', function (e) {
		e.preventDefault();
		var $this = $(this),
			shipmentUUID = $this.siblings('input[name$="ShipmentUUID"]').val(),
			giftItemsIndividually = $this.siblings('input[name$="IsGiftItemsIndividually"]').val(),
			confirmationUrl = util.appendParamsToUrl(Urls.mutishippingConfirmation, {ShipmentUUID: shipmentUUID, GiftItemsIndividually: giftItemsIndividually});
		dialog.open({
			url: confirmationUrl,
			options: {
				dialogClass: 'regroup-confirmation no-title yes-and-no-dialog',
				open: function () {
					// bind events for cancel and submit buttons
					$('#confirm-dialog-close').on('click', function () {
						dialog.close();
					});
					$('#confirm-dialog-continue').on('click', function (e) {
						var $shipmentContainer = $('#shipment-' + shipmentUUID);
						e.preventDefault();
						ajax.load({
							url: $(this).attr('href'),
							target: $shipmentContainer,
							callback: function () {
								initGifting();
								initMultiGiftMessageBox($shipmentContainer);
								util.limitCharatersCounter($shipmentContainer);
								util.limitCharacters($shipmentContainer);
								shippingMethods.init($shipmentContainer);
								$shipmentContainer.addClass('re-group-container');
								setTimeout(function () {
									$('select, input').uniform();
								}, 50);
							}
						});
						dialog.close();
					});
				}
			}
		});
	});

	$('.giftbutton[for="GIFTBAG"], .giftbutton[for="HAMPER"]').each(function () {
		var $radioButton = $(this).parents('.details-column').find('.input-radio.gifting-option');
		$(this).attr('for', $radioButton.attr('id'));
	});

	$('.gifting-fields').each(function () {
		var $this = $(this);
		var isHideGiftOptions = $this.find('.gifting-options').hasClass('visually-hidden');
		var isGiftValue = $this.find('[name$="_isGift"]').serialize().split('=').pop();

		if (!isHideGiftOptions && isGiftValue !== 'true') {
			$this.find('[name$="_isGift"]').trigger('click');
		}
	});
}

/**
 * @function
 * @description Initializes gift message box for multiship shipping, the message box starts off as hidden and this will display it if the radio button is checked to yes, also added event handler to listen for when a radio button is pressed to display the message box
 */
function initMultiGiftMessageBox($shipmentContainer) {
	var $multishipForm = null;
	// if a container is defined, limit this to that container
	if (typeof $shipmentContainer === 'undefined') {
		$multishipForm = $('form.checkout-multi-shipping');
	} else {
		$multishipForm = $shipmentContainer;
	}
	$('.do-not-open-wrapp').each(function () {
		if ($(this).find('textarea').val()) {
			$(this).addClass('active');
		}
	});

	//handle initial load
	//DaG HC-928 issue #12 Not need to hide any gift option
	//giftingFieldsToggle($multishipForm.find('.gifting-fields'));
	//handle selected gifting options on load
	giftingOptionSelectionUIHandler($multishipForm);
	//init lines and chars limits for gift message text area
	initGiftMsgTextArea($multishipForm);

	$multishipForm.find('.this-is-gift').each(function () {
		var $this = $(this);

		//set event listeners
		$this.on('change', function () {
			var $controlElement = $(this).closest('.gifting-fields');
			var $shipmentControl = $controlElement.find('.this-is-gift');
			// change the checked state of the other yes/no checkbox
			$shipmentControl.each(function () {
				if ($(this).attr('id') !== $this.attr('id')) {
					$(this).prop('checked', !$this.prop('checked')).parent().toggleClass('checked');
				}
			});
			$controlElement.find('.gifting-options').toggleClass('visually-hidden', $controlElement.find('input[name$="_isGift"]:checked').val() !== 'true');
			// clear the gift messages that are in the fields
			if ($controlElement.find('input[name$="_isGift"]:checked').val() === 'false') {
				$multishipForm.find('textarea[name$="_recipientMessage"]').val('');
				$multishipForm.find('input[name$="_recipientName"]').val('');
				$multishipForm.find('input[name$="_recipientDelMessage"]').val('');
				$multishipForm.find('input[name$="_recipientSuppressSender"]').prop('checked', false).parent().removeClass('checked');
			}
		});
	});
	$multishipForm.find('.delivery-list-title-wrapp').each(function () {
		var $this = $(this);
		$this.click(function () { $this.parent().toggleClass('active');});
	});

	$multishipForm.on('change', '.checkbox-container.shipping-method', function () {
		$(this).parents('.shipping-methods').find('.checkbox-container.shipping-method').removeClass('active');
		$(this).toggleClass('active');
		var preselectedDate = $(this).find('.second-line-delivery-info .first-available-day').attr('data-arrival-date');

		if (!preselectedDate) {
			preselectedDate = $(this).find('.nominated-date').val();
		}
		var shippingMethodID = $(this).find('input.input-radio').val();
		$(this).parents('.shipping-methods').find('input[name$="_nominatedDate"]').val(preselectedDate);
		var $shippingMethodInput = $(this).parents('.shipping-methods').find('input[name$="_shippingMethodID"]');
		$shippingMethodInput.val(shippingMethodID);
		$shippingMethodInput.trigger('change').trigger('click');
	});

	$multishipForm.find('.shipment-gifting-container').each(function () {
		var $this = $(this);
		// pre-select shipping method based on value
		var $selectedShippingMethod = $this.find('input[name$="_shippingMethodID"]');
		var selectedMethodID = $selectedShippingMethod.val();
		var $defaultDelivery = $this.find('.checkbox-container.shipping-method').first();
		if (selectedMethodID) {
			var selectedMethodInput = $this.find('input[value="' + selectedMethodID + '"]');
			if (selectedMethodInput.length) {
				$defaultDelivery = selectedMethodInput.parents('.shipping-method');
			}
		}
		$defaultDelivery.find('.radio span').addClass('checked');
		$defaultDelivery.trigger('change');

		var $selectedGiftOption = $this.find('[name$="_giftingPackagePID"]');
		var selectedGiftOptionID = $selectedGiftOption.val();
		if (selectedGiftOptionID) {
			var selectedGiftOptionInput = $this.find('input[value="' + selectedGiftOptionID + '"].gifting-option');
			if (selectedGiftOptionInput.length) {
				$('label[for="' + selectedGiftOptionInput.attr('id') + '"]').trigger('click');
			}
		}
		window.console.log(selectedMethodID, selectedGiftOptionID);
	});

	$multishipForm.find('.datepicker-open-date').each(function () {
		var $container = $(this).closest('.calendar');
		jcalendar.init($(this), {
			'container': $container,
			'closeButtonNeeded': true,
			'callback': function () {
				$container.find('div.change').removeClass('visually-hidden');
				$container.find('div.select').addClass('visually-hidden');
			}
		});
	});

	//handle different viewport
	$(window).smartresize(function () {
		//DaG HC-928 issue #12 Not need to hide any gift option
		//giftingFieldsToggle($multishipForm.find('.gifting-fields'));
	});

	$('input[name$="recipientName"]').on('keydown', function (event) {
		if (event.keyCode === 13) {
			event.preventDefault();
			return false;
		}
	});

	$multishipForm.on('change', 'input[name$="_recipientDelMessage"]', function () {
		$(this).parents('.shipping-methods').find('.do-not-open-until-title span').text($(this).val());
	});
}

function initGiftMsgTextArea($multishipForm) {
	var constants = window.Constants;
	if (!constants.HANDLE_GIFT_MSG_LINE_BREAKS) {
		return;
	}
	// handle gift area update and number of lines limitation
	var $giftTextArea = $multishipForm.find('textarea[name$="_recipientMessage"]'),
		lineCount = constants.GIFT_MSG_LINE_COUNT,
		perLine = constants.GIFT_MSG_CHARS_PER_LINE,
		ignoreNewMultiLinesMerge = constants.GIFT_MSG_MERGE_NEW_LINES;

	$giftTextArea.on('paste', function () {
		setTimeout(200, $giftTextArea.change);
	});

	$giftTextArea.on('change input', function () {
        var $this = $(this);
        var text = $this.val();
        var lines = text.split('\n');
        var newLines = [];
        var previousLine = '';
        var lastWordIndex;

        for (var i = 0; i < lines.length; i++) {
            var currentLine = lines[i] || '';
            if (newLines.length > lineCount) {
                break;
            }

            if (currentLine.length > perLine) {
                var lastWordIndex = currentLine.slice(0, perLine + 1).lastIndexOf(' ');
                // console.log(i, '/', newLines.length, 'cut at', lastWordIndex);
                if (i < lineCount) {
                    if (lastWordIndex < 1) {
                        lastWordIndex = perLine;
                    }
                    var lastWord = currentLine.substr(lastWordIndex).trim();
                    currentLine = currentLine.substring(0, lastWordIndex);
                    var nextLine = lines[i + 1] || '';
                    nextLine = lastWord + ' ' + nextLine;
                    if (lines.length > i) {
                        lines[i + 1] = nextLine.trim();
                    } else {
                        lines.push(nextLine.trim());
                    }
                } else {
                    currentLine = currentLine.substring(0, perLine);
                }
            }

            if (ignoreNewMultiLinesMerge || currentLine.length > 0 || previousLine.length > 0) {
                newLines.push(currentLine);
            }
            previousLine = currentLine;
        }

        var cursorPosition = $this.prop('selectionStart');

        $this.val(newLines.join('\n'));
        this.setSelectionRange(cursorPosition, cursorPosition);
    });
}

function giftingOptionSelectionUIHandler($multishipForm) {
	var radioButtons = $multishipForm.find('.option-select input[type="radio"]');
	//highlight the selected field
	radioButtons.filter(':checked').closest('.shipment-item-details').addClass('selected');
	$('.giftbutton').on('click',function () {
		if ($(this).parents('.gifts-wrapper').find('.shipment-item-details .content-asset.selected').length > 0) {
			if ($(this).parent().hasClass('selected')) {
				$(this).parent().toggleClass('selected');
				$(this).parents('.gifts-wrapper').removeClass('selected');
				$(this).closest('.gifting-options').find('.recipient-details__wrapper').removeClass('selected');
			} else {
				$(this).parents('.gifts-wrapper').find('.shipment-item-details .content-asset').toggleClass('selected');
				$(this).parents('.gifts-wrapper').addClass('selected');
				$(this).closest('.gifting-options').find('.recipient-details__wrapper').addClass('selected');
			}
		} else {
			$(this).parent().toggleClass('selected');
			$(this).parents('.gifts-wrapper').addClass('selected');
			$(this).closest('.gifting-options').find('.recipient-details__wrapper').addClass('selected');
		}
	});

	radioButtons.click(function () {
		var name = $(this).attr('name');
		//do nothing if it's selected gifting card
		if ($(this).attr('name').indexOf('giftingCardPID') !== -1 &&
				$(this).closest('.shipment-item-details').hasClass('selected')) {
			return;
		}
		var $giftingPackagePID = $(this).parents('.shipment-gifting-container').find('[name$="_giftingPackagePID"]');
		$(this).closest('.gifting-options-column').find('.shipment-item-details.selected').removeClass('selected');
		if ($(this).data('previousvalue') === true) {
			$(this).prop('checked', false);
			$(this).parent().removeClass('checked');
			$('input[name=' + name + ']').data('previousvalue', false);
			$giftingPackagePID.val('');
		} else {
			$('input[name=' + name + ']').data('previousvalue', false);
			$(this).data('previousvalue', true);
			$(this).parent().addClass('checked');
			$(this).closest('.shipment-item-details').addClass('selected');
			$giftingPackagePID.val($(this).val());
		}
		$giftingPackagePID.trigger('change');
	});

	$('[name$="_giftingPackagePID"], input[name$="_shippingMethodID"]').on('change', _.debounce(updateDeliverySummary, 300));
}

/**
 * @function
 * @description handle summary update for shipping method and gifting options update
 */
function updateDeliverySummary () {
	var $multishipForm = $('form.checkout-multi-shipping');
	var serializedForm = $multishipForm.serialize() + '&format=ajax&delivery=true';
	$.ajax({
		type: 'POST',
		url: Urls.summaryUpdate,
		data: serializedForm
	}).done(function (response) {
		if (!response) {
			window.console.error('Delivery selection failed');
			return;
		}

		if (response.success) {
			$('.summary-wrapper').html(response.content);
			return;
		}
		window.console.error('Delivery selection failed', response);
	});
}

/**
 * @function
 * @description handle gifting option visibility based on state and viewport
 */
function giftingFieldsToggle ($giftOptions) { // eslint-disable-line no-unused-vars

	$giftOptions.each(function () {
		if (util.viewport.isStandard()) {
			$(this).find('.this-is-gift[value="true"]').prop('checked', true).trigger('change');
		}
		if (!util.viewport.isStandard()) {
			if ($(this).find('.this-is-gift[value="true"]:checked').length === 0) {
				$(this).find('.gifting-options').addClass('visually-hidden');
			}
		} else {
			$(this).find('.gifting-options').removeClass('visually-hidden');
		}
	});

}
/**
 * Update shipping address select for registered user UI
 * @param {HTMLElement} target - The clicked target element
 * @param {Object} address - The address object containing customerr address info
 * @param {String} selectedAddressUUID - The UUID of the selected address that was edited
 * @param {Boolean} add - The flag, to identify address action, create or edit
 * @param {Boolean} addToAddressBook - The flag, to identify adding this to Address Book
 */
function updateShippingAddressForRegistered(target, address, selectedAddressUUID, add, addToAddressBook) {
	var	$shippingAddress = $(target).closest('.shippingaddress'),
		$select = $shippingAddress.find('.select-address'),
		$selected = $select.find('option:selected'),
		$shippingAddressBlock = $(target).closest('.delivery-address-block'),
		$inputRadio = $shippingAddressBlock.find('.deliveryto-radio');

	var optionText = address.firstName + ' ' + address.lastName + ', ' + address.address1 + ', ' +
		address.city + (address.stateCode !== null ? ', ' + address.stateCode : '') +
		(address.postalCode !== null ? ', ' + address.postalCode : '');
	var newOption = '<option value="' + address.UUID + '" data-cs-mask>' + optionText + '</option>';
	$selected.removeAttr('selected');

	// consider case when editing saved address, will result in adding new session address
	var isAddressAdded = add;
	if (isAddressAdded) {
		$inputRadio = $shippingAddressBlock.find('.gift-radio');
		var $addressDetailsContainer = $shippingAddressBlock.find('.address-gift');
		var $addressDetails = $addressDetailsContainer.find('.address-details');
		updateAddressDetails($addressDetails, address);
		$addressDetails.removeClass('hidden');

		if (addToAddressBook) {
			$('.shippingaddress select').append(newOption);
		}
	} else {
		$('.shippingaddress select').find('option[value="' + selectedAddressUUID + '"]').replaceWith(newOption);
		$select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
		$.uniform.update($('.shippingaddress select').uniform());
		$select.siblings('span').attr('data-cs-mask', '');
	}

	// if there's no previously selected option, select it
	if ($selected.length === 0 || $selected.val() === '') {
		$select.find('option[value="' + address.UUID + '"]').prop('selected', 'selected').trigger('change');
	}
	// reinit select address form for validation
	if ($('.shipment-container .shippingaddress .select-address').length > 0) {
		formPrepare.init({
			continueSelector: '[name$="addressSelection_save"]',
			formSelector: '[id$="multishipping_addressSelection"]',
			keyup: false
		});
	}
	var editWithoutSelectingRadio = !add && !$inputRadio.is(':checked');
	if (editWithoutSelectingRadio) {
		return;
	}
	$inputRadio.val(address.UUID);
	$shippingAddressBlock.find('.selectedAddress').val(address.UUID).trigger('change');
}
/**
 * Updates the shhipping address block for guest user
 * @param {HTMLElement} target - The clicked target element
 * @param {Object} address - The address object containing customerr address info
 */
function updateShippingAddressForGuest(target, address, add) {
	var $shippingAddressBlock = $(target).closest('.delivery-address-block');
	var $inputRadio = $shippingAddressBlock.find('.deliveryto-radio');
	var $addressDetailsContainer = $shippingAddressBlock.find('.delivery-address');
	if (add) {
		$addressDetailsContainer = $shippingAddressBlock.find('.address-gift');
		$inputRadio = $shippingAddressBlock.find('.gift-radio');
	}
	var $addressDetails = $addressDetailsContainer.find('.address-details');
	$inputRadio.val(address.UUID);
	if (!add) {
		var $sameDeliveryRadioInputs = $('input.deliveryto-radio[value="' + address.UUID + '"]');
		$sameDeliveryRadioInputs.each(function(i, inputRadio) {
			var $address_details = $(inputRadio).closest('.delivery-address').find('.address-details');
			updateAddressDetails($address_details, address);
		});
	} else {
		updateAddressDetails($addressDetails, address);
	}

	var editWithoutSelectingRadio = !add && !$inputRadio.is(':checked');
	if (editWithoutSelectingRadio) {
		return;
	}
	$shippingAddressBlock.find('.selectedAddress').val(address.UUID).change();
	$addressDetails.removeClass('hidden');
}
/**
 * Updates address details section (UI)
 * @param {jQuery} $addressDetails - address details section
 * @param {Object} address - The address object containing customerr address info
 */
function updateAddressDetails ($addressDetails, address) {
	$addressDetails.find('.name').text(address.firstName + ' ' + address.lastName);
	$addressDetails.find('.address1').text(address.address1);
	if (address.address2) {
		$addressDetails.find('.address2').length
			? $addressDetails.find('.address2').text(address.address2)
			: $addressDetails.find('.address1').after($('<p class="address2">' + address.address2 + '</p>'));
	} else {
		$addressDetails.find('.address2').remove();
	}
	$addressDetails.find('.city-and-code').text(address.city + ', ' + address.postalCode);
	$addressDetails.find('.country').text(address.countryCode);
}
/**
 * @function
 * @description capture add edit address form events
 * target is a element clicked
 */
function addEditAddress(target, selectedAddressUUID) {
	var $addressForm = $('form.address[name$="multishipping_editAddress"]'),
		add = true,
		selectedAddress;
	if (selectedAddressUUID) {
		// TODO: if ('isInvalid') append text message
		var $validationAddressData = $('.session-address-verification[uuid="' + selectedAddressUUID + '"]').first();
		if ($validationAddressData.length && !$validationAddressData.attr('valid')) {
			console.log('this address is invalid and should be updated', selectedAddressUUID, $validationAddressData.attr('valid'));
		}
		selectedAddress = $.grep($addressForm.data('addresses'), function (add) {
			return add.UUID === selectedAddressUUID;
		})[0];
		util.fillAddressFields(selectedAddress, $addressForm);
		add = false;
		$addressForm.find('option[value="' + selectedAddressUUID + '"]').prop('selected', 'selected').trigger('change');
	}

	// initialize events
	$addressForm.validate();
	address.dynamicAddressFieldsHandler($addressForm);
	$addressForm.find('select, .add-to-addressbook .input-checkbox').uniform();
	loqate.init($addressForm);

	$("input[type='text'][name*='_addressFields_']").on('change', function () {
		this.value = util.replaceInvalidChars(this.value);
	});

	if ($(target).hasClass('edit')) {
		$addressForm.find('.enter-manually').trigger('click');
	}

	$addressForm.on('click', '.cancel', function (e) {
		e.preventDefault();
		dialog.close();
	});

	$addressForm.on('submit', function (e) {
		e.preventDefault();
		$addressForm.find('.enter-manually').click();
		var action = add ? 'create' : 'edit';
		if (!$addressForm.valid()) {
			return false;
		}
		var addToAddressBook = $addressForm.find('[name*="addToAddressBook"]').serialize() ? true : false;

		var url = util.appendParamsToUrl(Urls.addEditAddress, {action: action});
		$.getJSON(url, $addressForm.serialize(), function (response) {
			if (!response.success) {
				// update form with validaiton results
				if (!response.validationResult) {
					console.error('No validationResult in response');
				}

				var isFieldValid, field;
				for (var fieldName in response.validationResult) {
					isFieldValid = response.validationResult[fieldName];
					field = $addressForm.find('[name="' + fieldName + '"]');
					if (isFieldValid) {
						field.removeClass('error').parents('.form-row').removeClass('error');
					} else {
						field.addClass('error').parents('.form-row').addClass('error');
					}
				}
				// show full address details
				$addressForm.find('.enter-manually').trigger('click');
				// scroll to first field with error
				$([document.documentElement, document.body]).animate({
					scrollTop: $addressForm.find('.form-row.error').first().offset().top
				}, 1000);

				return false;
			}
			// need to keep track of addresses stored in session address book
			// in order to run validation
			var address = response.address;
			// TODO: update session based storage address
			var $validationAddressData = $('.session-address-verification[uuid="' + address.UUID + '"]').first();
			if ($validationAddressData.length) {
				console.log('updating address in', $validationAddressData, response.addressJSON);
				$validationAddressData.text(JSON.stringify(response.addressJSON));
			}

			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.deliveryAddAddress(e, address);
			}

			var isRegistered = $('.checkout.delivery').hasClass('registered-customer');
			if (isRegistered) {
				updateShippingAddressForRegistered(target, address, selectedAddressUUID, add, addToAddressBook);
			} else {
				updateShippingAddressForGuest(target, address, add);
			}
			if (response.success) {
				dialog.close();
			}
		});
	});

}

/**
 * @function
 * @description Initializes event listener for Send To Multiple Addresses and Send To A Single Address buttons
 */
function initSendToAddresses() {
	$('.send-to-addresses').on('click', function () {
		var params = {
				ShipType: $('input[name="ShipType"]').val(),
				isSms: $(this).hasClass("shipment-type-sms")
		};
		var url = util.appendParamsToUrl(Urls.mutishippingStart, params);
		if ($(this).hasClass('single')) {
			dialog.open({
				url: Urls.sendToASingleAddress,
				options: {
					dialogClass: 'yes-and-no-dialog sending-to-recipient',
					buttons: [
						{
							text: Resources.CANCEL,
							'class':'button-gray cancel',
							click: function () {
								$(this).dialog('close');
							}
						},
						{
							text: Resources.SEND_TO_A_SINGLE_ADDRESS,
							click: function () {
								window.location.href = url;
							}
						}
					],
					title: Resources.TITLE_CONTINUE,
					open: function () {
						var $dlg = $(this).parent();

						// Wrap titlebar + content if not already wrapped
						if ($dlg.find(".content__wrapper").length === 0) {
							$dlg.find(".ui-dialog-titlebar, .ui-dialog-content")
								.wrapAll('<div class="content__wrapper"></div>');
						}

						// Defer wrapping of buttons to after jQuery UI finishes rendering them
						setTimeout(function () {
							if ($dlg.find(".btns__wrapper").length === 0) {
								$dlg.find(".ui-dialog-buttonpane")
									.wrap('<div class="btns__wrapper"></div>');
							}
						}, 0);
					}
				}
			});
		} else {
			window.location.href = url;
		}
	});
}

/**
 * @function
 * @description Opens pop-up if customer is over shipment limit
 */
function openMaxShipmentsLimitWarning() {
	dialog.open({
		url: Urls.maxShipmentsPopup,
		options: {
			dialogClass: 'max-shipments-limit-dialog',
			buttons: [
				{
					text: Resources.GOT_IT,
					click: function () {
						$(this).dialog('close');
					}
				}
			],
			title: Resources.BIG_SENDER
		}
	});
}

/**
 * @function
 * @description Initializes event listener for Continue Securely button
 * 				to check max shipments limit on click
 */
function initCheckMaxShipmetsLimit() {
	$('.checkout-multi-shipping').on('click', 'button[name$=_addressSelection_save]', function (e) {
		if ($('input[name=ShipmentLimitExceeded]').length > 0) {
			e.preventDefault();
			var maxShipUrl = util.appendParamsToUrl(Urls.checkMaxShipments);

			ajax.getJson({
				url: maxShipUrl,
				data: {ShipmentLimitExceeded: $('input[name="ShipmentLimitExceeded"]').val()},
				callback: function (response) {
					if (response.success && response.limitExceeded) {
						openMaxShipmentsLimitWarning();
					}
				}
			});
		}
	});
}

/**
 * @function
 * @description toggle radio buttons when select type of delivery on checkout
 */
function initDeliveryTypeTabs() {
	var $shipmentContainer = $(this).closest('.shipment-container');
	var $deliveryType = $shipmentContainer.find('input[name*="deliveryType"]');
	var $deliveryTab = $(this).find('[data-delivery-type="' + $deliveryType.val() + '"]');
	if (!$deliveryTab.length) {
		console.log('Can not find tab ', $deliveryType.val(), this);
		return;
	}

	$(this).tabs('option', 'active', $deliveryTab.index());
	// $.uniform.update('.input-radio');
}

/**
 * @desc when selected delivery option content shown, update deliveryType value
 */
function deliveryOptionHandler (e, ui) {
	var $activeTab = ui.newTab;
	var deliveryType = $activeTab.data('delivery-type');
	var $shipmentContainer = $(this).closest('.shipment-container');
	var $deliveryType = $shipmentContainer.find('input[name*="deliveryType"]');
	$deliveryType.val(deliveryType).change();
}

/**
 * @desc process the interaction with custom store list dropdown
 */
function storeListCustomSelection () {
	var $listContainer = $('.store-pickup-container'),
		storeListContainers = [];

	$listContainer.each(function (innerCounter) {
		var $storeList = $(this).find('.storelist-wrapper'),
			scrollElement,
			storelistID = 'storelist' + innerCounter;

		$storeList.attr('id', storelistID);
		if (!util.isMobile()) {
			scrollElement = document.getElementById(storelistID);
			storeListContainers[innerCounter] = new IScroll(scrollElement, util.iscrollParams());
		}

		$(this).on('click', '.label', function () {
			var $storeList = $(this).prev();
			$(this).toggleClass('hover');
			$storeList.toggleClass('active');
			if ($storeList.hasClass('active')) {
				if (scrollElement) {
					setTimeout(function () {
						storeListContainers[innerCounter].refresh();
					}, 100);
				} else {
					$storeList.addClass('mobile-scroll');
				}
			} else {
				var $container = $(this).closest('.clickandcollect-block');
				var $inputField = $container.find('input.store-pickup');
				if ($inputField.val()) {
					$container.find('.store-pickup-container__selected').removeClass('visually-hidden');
					$container.find('.store-pickup-container').addClass('visually-hidden');
				}
			}

		});
	});

	$('.storelist-wrapper .inner-wrapper > div').on('click', function () {
		var container = $(this).closest('.clickandcollect-block'),
			storeID = $(this).data('storeid'),
			inputField = container.find('input.store-pickup'),
			prevValue = container.find('.storelist-wrapper div.selected');

		if ($(this).hasClass('selected')) {
			$(this).removeClass('selected');
			container.find('.label span').html('<span class="default">' + Resources.SELECT_A_STORE + '</span>');
			inputField.val('').trigger('change');

		} else {
			$(this).addClass('selected');
			container.find('.label span').html($(this).html());
			inputField.val(storeID).trigger('change');
			if (prevValue.length > 0) {
				prevValue.removeClass('selected');
			}
			container.find('.storelist-wrapper').removeClass('active');
		}
		var $container = $(this).closest('.clickandcollect-block');
		$container.find('.store-pickup-container__selected').removeClass('visually-hidden');
		$container.find('.store-pickup-container').addClass('visually-hidden');
		var htmlContent = $(this).html();
		var cleanedHtml = htmlContent.replace(/,/g, '');
		$container.find('.store-pickup-container__selected .selected-store-details').attr('data-storeid', $(this).data('data-storeid')).html(cleanedHtml);
	});

	$('input.store-pickup').on('change', function () {
		var $storeInput = $(this);
		var $storePickUpContainer = $storeInput.closest('.store-pickup-container');
		var inputValue = $storeInput.val();
		if (inputValue) {
			$storePickUpContainer.removeClass('error');
		} else {
			$storePickUpContainer.addClass('error');
		}
	});
}
/**
 * @function
 * @description executes on shipping address form submission
 * checks if invalid addresses left, if not submits the form
 */
function onShippingAddressSubmit(e) {
	e.preventDefault();
	// use submitButtonID in further tracking of the delivery restrictions and to determine the submit action
	var submitButtonID = e.currentTarget.id ? e.currentTarget.id : e.currentTarget.name;
	$('input[name$="submitButtonID"]').val(submitButtonID);

	// check if there any invalid addresses left before submitting
	if (!checkInvalidAddresses()) {
		return console.log('there is some invalid addresses left');
	}

	if (!checkSelectedStore()) {
		return console.log('the store not selected');
	}

	submitAfterValidation();
}

/**
 * @desc submit after validating all the shipment addresses,
 * check value of submitButtonID as an indication of the submit action,
 * opens dialog with international delivery restriction or submits the form,
 * initialize event listeners on click 'Remove Items' button and 'Change Address' button
 */
function submitAfterValidation() {
	var submitButtonID = $('input[name$="submitButtonID"]').val();
	if (!submitButtonID) {
		return;
	}
	// clear submit button id to avoid double submit
	$('input[name$="submitButtonID"]').val('');
	// Get the form
	var $form = $('[id$="multishipping_addressSelection"]');
	var shipmentsInfo = [];
	var $shipmentContainers = $('.shipment-container');

	// Build array of shipments with address IDs
	$shipmentContainers.each(function () {
		var deliveryType = $(this).find('input[name$="deliveryType"]').val();
		var addressID = $(this).find('.selectedAddress').val();
		var shipmentObject = {};
		shipmentObject.type = deliveryType;
		shipmentObject.addressID = addressID;
		// Add to Array of shipments
		shipmentsInfo.push(shipmentObject);
	});

	// Open dialog or submit the form
	$.ajax({
		type: 'POST',
		url: Urls.checkDeliveryRestrictions,
		data: {shipmentsInfo: JSON.stringify(shipmentsInfo)}
	}).done(function (response) {
		var responseObj = $.parseJSON(response);
		if (!responseObj.success) {
			var url = util.appendParamsToUrl(Urls.deliveryRestrictionDialog, {ineligibleShipment: response});
			// GTM Linchpin analytics
			if (SitePreferences.GTM_ENABLED) {
				linchpin.deliveryRestriction(submitButtonID, responseObj.country, response);
			}
			dialog.open({
				url: url,
				options: {
					title: Resources.DELIVERY_RESTRICTION_TITLE,
					dialogClass:'delivery-restriction-dialog',
					open: function () {
						// init cancel event
						$('.change-restricted-address').on('click', function () {
							dialog.close();
						});
						// init remove items event
						$('.remove-restricted-items').on('click', function () {
							var productIDs = '';
							$('input[name="productID"]').each(function () {
								if (productIDs === '') {
									productIDs += $(this).val();
								} else {
									productIDs += ',' + $(this).val();
								}
							});
							var options = {
								url: util.appendParamsToUrl(Urls.removeRestrictedItems, {productsToRemove: productIDs})
							};
							$.ajax(options).done(function (response) {
								if (response.baskethasitems === true) {
									window.location.href = Urls.mutishippingStart;
								} else {
									window.location.href = Urls.cartShow;
								}
							});
						});
					},
					buttons: []
				}
			});
		} else {
			// Submit the form
			$form.off('submit', onShippingAddressSubmit);
			$('button[name$="_addressSelection_save"]').trigger('click');
		}
	});
}

/**
 * @function
 * @description initialize event listener on shipping address form submission
 */
function initInternationalDeliveryRestriction () {
	$('[id$="multishipping_addressSelection"]').on('submit', onShippingAddressSubmit);
}

function openEditAddressPropmt (addressUUID, target) {
	var url = target ? target.href : Urls.editShippingAddress;
	dialog.open({
		url: url,
		options: {
			dialogClass:'shipping-address-dialog',
			open: function () {
				linchpin.trackPageView(true);
				addEditAddress(target, addressUUID);
			},
			close: function () {
				var giftRadios = $('input.gift-radio');
				giftRadios.each(function(i, el) {
					var elValue = $(el).val();
					if (!elValue.length) {
						$(el).closest('.delivery-address-block').find('.deliveryto-radio').trigger('click');
					}
				});
				linchpin.trackPageView(false);
			}
		}
	});
}

/**
 * @function
 * @description Initializes the events on the address form dialog popup (apply, cancel, delete)
 * @param {Element} form The form which will be initialized
 */
function initializeAddressForm ($validationData) {
	// Removes focus from select drop-down list when overlay is clicked
	$('.ui-widget-overlay').bind('click', function () {
		$('select').each(function () {
			$(this).blur();
		});
	});

	var $form = $('#dialog-container #edit-address-form');
	address.dynamicAddressFieldsHandler($form);
	formPrepare.replaceInvalidCharsInit($form);

	$form.find('input[name="format"]').remove();
	$form.validate();
	$('<input/>').attr({
		name: $form.find('.apply-button').attr('name'),
		type: 'hidden',
		value: 'apply'
	}).appendTo($form);

	$form.on('click', '.apply-button', function (e) {
		e.preventDefault();
		if (!$form.valid()) {
			return false;
		}
		var options = {
			url: $form.attr('action'),
			data: $form.serialize() + '&format=ajax',
			type: 'POST'
		};
		$.ajax(options).always(function (data) {
			if (data && data.success) {
				$validationData.attr('valid', true);
				dialog.close();
				var addressData = data.address;
				if (addressData) {
					var addressText = addressData.firstName + ' ' + addressData.lastName + ', ' + addressData.address1 + ', ' + addressData.city + ', ' + addressData.stateCode;
					var uuid = $validationData.attr('uuid');
					validateShippingAddress(uuid);
					var $addressOption = $('select.select-address option[value="' + uuid + '"]');
					$addressOption.each(function () {
						$(this).text(addressText);
						$('select.select-address option[value="' + uuid + '"]:selected').parent().siblings('span').text(addressText);
					});
				}
			} else {
				// update content with validated form HTML
				var formValidated = $(data).filter("#edit-address-form");
				$form.html(formValidated.html());
				// init events
				formPrepare.replaceInvalidCharsInit($form);
				address.dynamicAddressFieldsHandler($form);
				// scroll to first field with error
				$([document.documentElement, document.body]).animate({
					scrollTop: $form.find('.form-row.error').first().offset().top
				}, 1000);
			}
		});
	});

	// click to trigger validation
	$form.find('button[type="submit"]').click();
	return $form;
}

function updateInvalidAddress($addressData) {
	var url = $addressData.attr('url');
	dialog.open({
		url: url,
		options: {
			buttons:[],
			dialogClass: 'shipping-address-dialog addressbook',
			open: function () {
				initializeAddressForm($addressData);
			}
		}
	});
}

function updateFormWithAddressData ($form, $data) {
	var data = JSON.parse($data.text()), input;
	console.log(data);
	for (var addressKey in data) {
		input = $form.find('[name$="_' + addressKey + '"]').first();
		input.val(data[addressKey]);
	}
	return data;
}

/**
 * @function
 * @description invoke validation request to check if stored address is valid, shows edit address pop up if not
 */
function validateShippingAddress(addressUUID) {
	var $validationForm = $('#address-verification > form').first();
	if (!addressUUID || !$validationForm || $validationForm.length < 1) {
		return console.log('no  validation form included');
	}
	// session addresses will be in first place to overwrite validation if saved address where presented before
	var $addressData = $('.address-verification[uuid="' + addressUUID + '"], .session-address-verification[uuid="' + addressUUID + '"]').first();
	if (!$addressData || $addressData.length < 1) {
		return console.log('no address included, so that should be a new address', addressUUID);
	}
	var addressID = $addressData.attr('name');
	if ($addressData.attr('valid') === 'true') {
		return console.log('already validated', addressID, addressUUID);
	}

	try {
		updateFormWithAddressData($validationForm, $addressData);
	} catch (e) {
		return console.log(e);
	}

	try {
		address.dynamicAddressFieldsHandler($validationForm);
	} catch (e) {
		console.log(e);
	}

	var data = $validationForm.serialize();
	var url = $addressData.attr('checkURL');
	// Open dialog or submit the form
	$.ajax({
		type: 'POST',
		url: url,
		data: data
	}).done(function (response) {
		if (!response.success) {
			$addressData.attr('valid', false);
			// do special handling if that is session address
			if ($addressData.hasClass('session-address-verification')) {
				var $invalidOption = $('.selectedAddress[value="' + addressUUID + '"]').first();
				if ($invalidOption.length) {
					var editButton = $invalidOption.closest('.delivery-address-block').find('.edit')[0];
					openEditAddressPropmt(addressUUID, editButton);
				} else {
					// if there no way to handle that case then mark it as valid
					$addressData.attr('valid', true);
					console.log('no select with such UUID', addressUUID, $invalidOption);
				}
			} else {
				updateInvalidAddress($addressData);
			}
		} else {
			$addressData.attr('valid', true);
		}
		var allAddressesValid = getIfAllAddressesValid();
		// submit the form if all addresses are valid
		if (allAddressesValid) {
			submitAfterValidation();
		}
	});

	// mark that validation started
	return true;
}

/**
 * @desc checks if all stored addresses validated,
 * returns false if any of addresses is invalid
 */
function getIfAllAddressesValid() {
	var $addressSelects = $('select.select-address');
	for (var i = 0, len = $addressSelects.length; i < len; i++) {
		var addressUUID = $($addressSelects[i]).val();
		var $addressData = $('.address-verification[uuid="' + addressUUID + '"], .session-address-verification[uuid="' + addressUUID + '"]').first();
		if ($addressData.attr('valid') === 'false') {
			return false;
		}
	}
	return true;
}

/**
 * @function
 * @description check addresses marked as invalid
 */
function checkInvalidAddresses() {
	var invalidAddresses = $('.address-verification[valid="false"]');
	if (invalidAddresses.length > 0) {
		if (validateShippingAddress(invalidAddresses.first().attr('uuid'))) {
			return false;
		}
	}
	var $addressSelects = $('select.select-address');
	for (var i = 0, len = $addressSelects.length; i < len; i++) {
		if (validateShippingAddress($($addressSelects[i]).val())) {
			return false;
		}
	}
	return true;
}

/**
 * @description check
 * @returns
 */
function checkSelectedStore() {
	var $storePickUpActivedTabs = $('.tab-nav-store-delivery.ui-state-active');
	var response = true;
	if (!$storePickUpActivedTabs.length) {
		return response;
	}
	$storePickUpActivedTabs.each(function () {
		var storeInputContainerID = $(this).attr('aria-controls');
		var $storeInput = $('#' + storeInputContainerID).find('input.store-pickup');
		var $storePickUpContainer = $storeInput.closest('.store-pickup-container');
		var value = $storeInput.val();
		if (!value) {
			$storePickUpContainer.addClass('error');
			response = false;
		} else {
			$storePickUpContainer.removeClass('error');
		}
	});
	return response;
}

/**
 * @function
 * @description initialize event listener on shipping address selector change
 */
function initShippingAddressValidation () {
	$('.shiptoaddress-block').on('change', 'select.select-address', function () {
		var $shippingAddressBlock = $(this).closest('.delivery-address-block');
		var $inputRadio = $shippingAddressBlock.find('.deliveryto-radio');
		if ($inputRadio.is(':checked')) {
			$shippingAddressBlock.find('.selectedAddress').val($(this).val()).change();
		}
	});
	$('.delivery-address-block').on('change', '.selectedAddress', function () {
		validateShippingAddress($(this).val());
	});
	checkInvalidAddresses();
	// check primary address
	validateShippingAddress($('#address-verification').first().attr('uuid'));
}

/**
 * @function
 * @description initialize delivery options tabs
 */
function initDeliveryTabs () {
	$('.delivery-tabs').each(function () {
		$(this).tabs({
			activate: deliveryOptionHandler,
			create: initDeliveryTypeTabs
		});
	});
}

/**
 * @function
 * @description tracking events interactions
 */
 function initTracking () {
	if (!SitePreferences.GTM_ENABLED) {
		return;
	}

	// handle one time event for interaction with gift message input
	$('textarea[name$="_recipientMessage"]').off('focus.linchpin').one('focus.linchpin', function() {
		linchpin.trackEvent('giftingMessageInteraction', 'Click');
	});
	$('textarea[name$="_recipientMessage"]').off('input.linchpin').one('input.linchpin', function() {
		linchpin.trackEvent('giftingMessageInteraction', 'Input');
	});

	// gift wrapping selected
	$('input[name$="_giftingPackagePID"]').off('change.linchpin').on('change.linchpin', function() {
		var giftingPackageProduct = $(this).val();
		linchpin.trackEvent('giftingOptionSelected', giftingPackageProduct, 'gift_option');
	});

	// gift recipient name
	$('input[name$="_recipientName"]').off('focus.linchpin').one('focus.linchpin', function() {
		linchpin.trackEvent('giftingRecipientAdded', 'Click');
	});
	$('input[name$="_recipientName"]').off('input.linchpin').one('input.linchpin', function() {
		linchpin.trackEvent('giftingRecipientAdded', 'Input');
	});

	// do no open until date input
	$('input[name$="_recipientDelMessage"]').off('change.linchpin').on('change.linchpin', function() {
		var dateValue = $(this).val();
		linchpin.trackEvent('giftingDoNotOpenUntilPicked', dateValue ? 'YES' : 'NO');
	});

	// Secred Admirer checkbox
	$('input[name$="_recipientSuppressSender"]').off('change.linchpin').on('change.linchpin', function() {
		var isSecredAdmirer = $(this).is(':checked');
		linchpin.trackEvent('giftingSecretAdmirerSelected', isSecredAdmirer ? 'YES' : 'NO');
	});
}

function showHideEORINumberInput(e) {
	var $target = $(e.target);
	var $niSection = $target.closest('.shipping-details-ni');
	var targetId = $target.attr('id');
	var isNiTrue = targetId.indexOf('ni_delivery_true') !== -1;
	var isCheckedTrue = $target.is(":checked");
	var $eoriSection = $niSection.find('.shipping-details-ni-eori-number');
	if (isNiTrue && isCheckedTrue) {
		$eoriSection.removeClass('hidden');
		$(".shipping-details-ni-eori-number").find('input').addClass('required');
		formPrepare.init({
			continueSelector: '[name$="shippingOptions_save"]',
			formSelector: '.address.checkout-multi-shipping',
			keyup: true,
			errorPlacementNI: function(error, element) {
				if ($(element).attr('name').indexOf('EORINumberNI') !== -1) {
					$(element).parents('.form-row').append(error);
				}
			}
		});
	} else {
		$eoriSection.addClass('hidden');
		$eoriSection.find('input').removeClass('required');
		var $btnContinue = $('.checkout-cta-buttons__wrapper button.continue');
		$btnContinue.removeAttr('disabled');
	}
}

/**
 * @function
 * @description shows gift message box in multiship, and if the page is the multi shipping address page it will call initmultishipshipaddress() to initialize the form
 */
exports.init = function () {
	storeListCustomSelection();
	initGifting();
	initMultiGiftMessageBox();
	initSendToAddresses();
	initDeliveryTabs();
	shippingMethods.init();
	giftcert.initEditAddressPopup();
	initShippingAddressValidation();
	initTracking();
	// Display max shipments limit exceeded warning pop-up if this element exists
	if ($('#max-shipments-warning').length > 0) {
		openMaxShipmentsLimitWarning();
		// Init event listener for Continue Securely button
		initCheckMaxShipmetsLimit();
	}

	if ($('.shipment-container .shippingaddress .select-address').length > 0) {
		formPrepare.init({
			continueSelector: '[name$="addressSelection_save"]',
			formSelector: '[id$="multishipping_addressSelection"]',
			keyup: false
		});
	}

	if ($('.shipping-details-ni').length > 0) {
		formPrepare.init({
			continueSelector: '[name$="shippingOptions_save"]',
			formSelector: '.address.checkout-multi-shipping',
			keyup: false,
			errorPlacementNI: function(error, element) {
				if ($(element).attr('name').indexOf !== -1) {
					var $niSection = $(element).closest('.shipping-details-ni');
					$niSection.before(error);
					$('[id$="isBusinessNI-error"]').addClass('hide-error');
					$('form.address.checkout-multi-shipping').on('submit', function () {
						$('[id$="isBusinessNI-error"]').removeClass('hide-error');
					});
				}
			}
		});
	}
	$('.edit-giftcert').each(function () {
		var elm = $(this).find('.datepicker-checkout-giftcard');
		jcalendar.init(elm, {'container': $(this)});
	});
	$('.edit-address').on('click', 'a', function (e) {
		e.preventDefault();
		var addressUUID;
		var isRegistered = $('.checkout.delivery').hasClass('registered-customer');
		if (isRegistered) {
			addressUUID = $(e.target).parents('.delivery-address-block').find('.selector .select-address').val();
		} else {
			addressUUID = $(e.target).parents('.delivery-address-block').find('input.deliveryto-radio').val();
		}

		if (!addressUUID && $(e.target).hasClass('edit')) {
			return console.log('invalid address option, not editable');
		}
		if ($(e.target).hasClass('add')) {
			addressUUID = null;
		}
		openEditAddressPropmt(addressUUID, e.target);
	});

	$('.store-pickup-container__selected').on('click', '.edit-store-address .edit', function (e) {
		e.preventDefault();
		var $container = $(this).closest('.clickandcollect-block');
		$container.find('.store-pickup-container__selected').addClass('visually-hidden');
		$container.find('.store-pickup-container').removeClass('visually-hidden');
		$container.find('.store-pickup-container .label.selector').trigger('click');
	});

	$('input[type=radio][name*="delivery-option"]').on('change', function(e) {
		$(this).closest('.delivery-address-block').find('.form-group').toggleClass('checked');
		// $(this).closest('.form-group').toggleClass('checked');
		if ($(this).is('.gift-radio') && $(this).is(':checked')) {
			$(this).closest('.shippingaddress').find('.edit-address a.add').trigger('click');
			var elValue = $('input.gift-radio').first().val();
			if (elValue.length) {
				$(this).closest('.shippingaddress').find('.address-gift .address-details').removeClass('hidden');
			}
		} else {
			$(this).closest('.shippingaddress').find('.address-gift .address-details').addClass('hidden');
			var $shippingAddressBlock = $(e.target).closest('.delivery-address-block');
			$shippingAddressBlock.find('.selectedAddress').val($(this).val()).change();
			$('input.gift-radio').first().val('');
		}
	});

	// toggling components of Build a box bundle
	cart.toggleBaBComponents();

	initInternationalDeliveryRestriction();

	// GTM Linchpin analytics
	if (SitePreferences.GTM_ENABLED) {
		// used for express checkout cases: track payment info
		// as all payment data was already submitted at this stage of checkout
		linchpinCheckout.paymentInfoEvent();
	}
	$(document).on('change', 'input[name$="_isBusinessNI"]', showHideEORINumberInput);
};

